<template lang="pug">
.user-panel
  el-row
    el-col.padded(type="flex" justify="center")
      h5 Mi panel
      ul
        li
          router-link(:to="{name:'UserPanel'}")
            User32
            span Panel de usuario
        li
          router-link(:to="{name:'Packages'}")
            Package32
            span Descargas
        li
          router-link(:to="{name:'Tree'}")
            Playlist32
            span Hacer test
        li
          router-link(:to="{name:'Purchases'}")
            Purchase32
            span Mis compras
        li
          router-link(:to="{name:'Ranking'}")
            Star32
            span Ranking
        li
          router-link(:to="{name:'Stats'}")
            List32
            span Mis resultados
        li(@click="logout")
          Logout32
          span Desconectar

</template>

<script type="text/javascript">
import { mapState } from "vuex";

export default {
  name: "UserPanel",
  computed: mapState(["token", "username"]),
  data() {
    return {};
  },
  methods: {
    logout() {
      this.$store.commit("clean");
      this.$router.push({
        name: "Login",
      });
    },
  },
};
</script>
